import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Matricial formalism is here exemplified for two cases: a saxophon with 3 side holes and a loudspeaker placed at the input of a vented box. Using the electrical circuit formalism, derive how the input impedance of the saxophone or the vent can be calculated.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 4,
      rowsSize: [1, 2, 1.5, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Saxophone with 3 side holes",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/29/principle/saxophone.svg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/29/principle/principle-1.svg`,
                },
              },
              styles: {
                padding: "1%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data: "Go to the next slide to see the correct solution.",
                  direction: "row",
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
